import { IComponentOptions } from 'angular';
import nvSdcModule from '../../nv.sdcModule.module';
import { GridToolbarCtrl } from './nv-grid-toolbar.controller';

export const GridToolbarComponent: IComponentOptions = {
  template: require('./nv-grid-toolbar.html'),
  bindings: {
    schoolId: '@',
    filter: '=',
    filters: '=',
    numDisplayedStudents: '=',
    numTotalStudents: '=',
    filteredStudentSet: '=',
    selectedTab: '=',
    allRowsButtonState: '=',
    loadDefaultColumns: '&',
    loadAllColumns: '&',
    refreshColumns: '&',
    refreshGridData: '&',
    allSelectedCols: '=',
    exportDataAsCsv: '&',
    currentUser: '<',
  },
  controller: GridToolbarCtrl,
  controllerAs: 'gridToolbarCtrl',
};

angular.module(nvSdcModule).component('nvGridToolbar', GridToolbarComponent);
